module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-alerts-panel3.b303217b.png";